import { SampleCategories, SampleVariant } from 'api';
import { TextField } from 'form';
import { InputAdornment, Stack } from 'ui';

import { DefaultBreakdownFormFields } from '../DefaultBreakdownFormFields/DefaultBreakdownFormFields';
import { ManualBreakdownFormFields } from '../ManualBreakdownFormFields/ManualBreakdownFormFields';

const BreakdownFormFields = ({ variant }: { variant?: SampleVariant }) => {
  switch (variant) {
    case 'alu':
      return (
        <ManualBreakdownFormFields
          fields={[
            {
              group: 'Aluminium',
              items: [
                { label: 'UBC', name: SampleCategories.aluminium_ubc },
                { label: 'Foil and Tray', name: SampleCategories.aluminium_foil_and_tray },
                { label: 'Food Can', name: SampleCategories.aluminium_food_can },
                { label: 'Other Aluminium', name: SampleCategories.aluminium_other },
                { label: 'Other Aluminium (aerosols)', name: SampleCategories.aluminium_other_aerosols },
              ],
            },
            {
              group: 'Non-Aluminium',
              items: [
                { label: 'Other Metal', name: SampleCategories.metal_other },
                { label: 'Non-Metal', name: SampleCategories.non_metal },
                { label: 'Rigid Plastics', name: SampleCategories.aluminium_rigid_plastics },
                { label: 'Vapes', name: SampleCategories.aluminium_vapes },
              ],
            },
          ]}
        />
      );

    case 'pet':
      return (
        <ManualBreakdownFormFields
          fields={[
            {
              group: 'PET Bottles',
              items: [
                { label: 'Clear', name: SampleCategories.pet_clear },
                { label: 'Clear (Large)', name: SampleCategories.pet_clear_large },
                { label: 'Clear (Full Sleeve)', name: SampleCategories.pet_clear_full_sleeve },
                { label: 'Light Blue', name: SampleCategories.pet_light_blue },
                { label: 'Dark Blue', name: SampleCategories.pet_dark_blue },
                { label: 'Green', name: SampleCategories.pet_green },
                { label: 'Other', name: SampleCategories.pet_other },
                { label: 'Non Food Grade PET Bottle', name: SampleCategories.non_food_grade },
              ],
            },
            {
              group: 'Other PET & Plastics',
              items: [
                { label: 'Clear PET Tray', name: SampleCategories.clear_tray },
                { label: 'Film', name: SampleCategories.film },
                { label: 'Other Plastic', name: SampleCategories.plastic_other },
                { label: 'Non Plastic', name: SampleCategories.non_plastic },
                { label: 'Prohibitive', name: SampleCategories.prohibitive },
                { label: 'Liquid', name: SampleCategories.liquid },
              ],
            },
          ]}
        />
      );
    case 'zorba':
      return (
        <ManualBreakdownFormFields
          fields={[
            {
              group: 'Target Material',
              items: [
                { label: "Non-ferrous Metal 'whites'", name: SampleCategories.non_ferrous_metal },
                { label: "Copper & Brass 'reds & yellows'", name: SampleCategories.copper_and_brass },
                { label: 'Post-consumer Aluminium Packaging', name: SampleCategories.aluminium_packaging },
                { label: 'Composite Materials', name: SampleCategories.composite },
                { label: 'Aluminium - foil / UBC', name: SampleCategories.aluminium_foil_ubc },
              ],
            },
            {
              group: 'Non-target',
              items: [
                { label: 'Other metal (ferrous)', name: SampleCategories.ferrous_metal },
                { label: 'Other Non-metal', name: SampleCategories.non_metal },
                { label: 'Fines <20mm', name: SampleCategories.fines },
                { label: 'Prohibitive', name: SampleCategories.prohibitive },
              ],
            },
          ]}
        />
      );
    case 'taintTabor':
      return (
        <ManualBreakdownFormFields
          fields={[
            {
              group: 'Target Material',
              items: [
                { label: 'Taint Tabor', name: SampleCategories.aluminium_tt },
                { label: 'Cast', name: SampleCategories.aluminium_cast },
                { label: 'Radiator/Condenser', name: SampleCategories.aluminium_radiator },
                { label: 'Foil/UBC', name: SampleCategories.aluminium_foil_ubc },
              ],
            },
            {
              group: 'Non-target',
              items: [
                { label: 'Ferrous Metal', name: SampleCategories.ferrous_metal },
                { label: 'Other Metal', name: SampleCategories.metal_other },
                { label: 'Non-Metal', name: SampleCategories.non_metal },
                { label: 'Fines <20mm', name: SampleCategories.fines },
                { label: 'Prohibitive', name: SampleCategories.prohibitive },
              ],
            },
          ]}
        />
      );
    default:
      return <DefaultBreakdownFormFields />;
  }
};

export const SampleFormFields = ({
  variant,
  disableBreakdown = false,
}: {
  variant?: SampleVariant;
  disableBreakdown?: boolean;
}) => {
  return (
    <Stack gap={2} minWidth={296}>
      <TextField
        name="total_weight"
        label="Total Weight"
        fullWidth
        required
        InputProps={{
          endAdornment: <InputAdornment position="end">Kg</InputAdornment>,
        }}
      />
      <TextField name="description" label="Notes" variant="filled" rows={2} fullWidth multiline />
      {!disableBreakdown && <BreakdownFormFields variant={variant} />}
    </Stack>
  );
};
